import React from 'react';
import { Flex, Box } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import { styles } from './styles';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';

const { wrapper, imageContainer, iconsWrapper, icon } = styles;

const HeroBlock07 = ({
  content: { text, images, collection },
  imageStyles,
}) => (
  <Flex sx={wrapper}>
    <ContentText content={text.slice(0, 3)} />
    <Flex sx={iconsWrapper}>
      {collection.map((col, index) => (
        <Flex key={`client-hero-${index}`} sx={icon}>
          <Icon content={col.icon} size='xs' />
          <ContentText content={col.text?.[0]} />
        </Flex>
      ))}
    </Flex>
    {images && (
      <>
        <Box sx={{ ...imageContainer, ...imageStyles }}>
          <ContentImages
            content={{ images: images.slice(0, 1) }}
            loading='eager'
            imagePosition='center'
          />
        </Box>
      </>
    )}
  </Flex>
);

export default WithDefaultContent(HeroBlock07);
